module.exports = {
  fr: {
    unconfirmed: 'Non validé(s)',
    confirmed: 'Validé(s)',
    wip: 'En cours de modif.',
    denied: 'Refusé(s)',
    pending: 'En attente de traitement...',
    resolved: "C'est fait !",
    loading: 'Chargement...',
    'wrong-password': 'Mot de passe incorrect',
    'user-not-found': 'Aucun compte avec cet email',
    error: 'Erreur inconnue, merci de contacter Labellecom',
    upload_video: "Upload vidéo",
    delete_video: "Supprimer la vidéo",
    short_weekdays: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    long_weekdays: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    change_request: 'Demande de modification',
    submit: "Soumettre",
    deny_post: "Refuser la publication",
    confirm_post: "Valider la publication",
    users: "Utilisateurs",
    modify_account: "Modifier le compte",
    change_lang: "Changer la langue",
    reset_password: 'Réinitialiser mot de passe',
    disconnect: "Se déconnecter",
    answer: 'Répondre',
    answer_placeholder: "Réponse...",
    password_reset: "Réinitialisation du mot de passe",
    post_calendar: "Calendrier des publications",
    forgotten_password: "Mot de passe oublié",
    today: "Aujourd'hui",
    more: "autre",
    account_name: "Nom du compte",
    add_users: "Ajout utilisateurs",
    cancel: "Annuler",
    delete_account: "Supprimer le compte",
    create_account: "Créer le compte",
    reset_email_sent: "Un email de réinitialisation du mot de passe vous à été envoyé à l'addresse",
    disable_notifications: "Désactiver les notif.",
    enable_notifications: "Activer les notifications",
    send: "Envoyer",
    send_account_email_desc: "Envoyer l'email de notification depuis une date précise aux utilisateurs choisis pour: ",
    send_notification: "Envoyer notif.",
    community_manager: "Community Manager",
    back: 'Retour',
    name: "Nom",
    notifications :"Notifications",
    language: "Langue",
    save_draft: "Sauvegarder (brouillon)",
    sponsor_budget: "Budget sponsorisation",
    add_thumbnail: "Ajouter thumbnail",
    draft: "Brouillon",
    visible: "Visible",
    confirm: "Confirmer",
    confirm_change_visible: "Cette action rendra le post visible, êtes-vous sûr ?",
    confirm_change_draft: "Passer le post en brouillon ?",
    total: "Total",
    planned: "Prévus",
    creas: "Créas",
    light: "Light",
    premium: "Premium",
    targets: "Objectifs",
    active: "Actif",
    accounts: "Comptes",
    character_count: "Nb de charactères",
    no_crea: "Pas de créa",

  },
  en: {
    unconfirmed: 'Not confirmed',
    confirmed: 'Confirmed',
    wip: 'Work in progress',
    denied: 'Denied',
    pending: 'Waiting for response...',
    resolved: "Done !",
    loading: 'Loading...',
    'wrong-password': 'Wrong password',
    'user-not-found': 'No user found with this email',
    error: 'Unknown error, please contact Labellecom',
    upload_video: "Video upload",
    delete_video: "Delete video",
    short_weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    long_weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    change_request: 'Request a change',
    submit: "Submit",
    deny_post: "Deny post",
    confirm_post: "Confirm post",
    users: "Users",
    modify_account: "Modify account",
    change_lang: "Change language",
    reset_password: 'Reset password',
    disconnect: "Disconnect",
    answer: 'Answer',
    answer_placeholder: "Answer here...",
    password_reset: "Password reset",
    post_calendar: "Publication calendar",
    forgotten_password: "Forgotten password",
    today: "Today",
    more: "more",
    account_name: "Account name",
    add_users: "Add users",
    cancel: "Cancel",
    delete_account: "Delete account",
    create_account: "Create account",
    reset_email_sent: "A reset email was sent to your email adress: ",
    disable_notifications: "Disable notifications",
    enable_notifications: "Enable notifications",
    send: "Send",
    send_account_email_desc: "Send notification email since the selected date for: ",
    send_notification: "Send notification",
    community_manager: "Community Manager",
    back: 'Back',
    name: "Name",
    notifications :"Notifications",
    language: "Language",
    save_draft: "Save (draft)",
    sponsor_budget: "Sponsor budget",
    add_thumbnail: "Add thumbnail",
    draft: "Brouillon",
    visible: "Visible",
    confirm: "Confirm",
    confirm_change_visible: "This action will make the post visible to all, are you sure ?",
    confirm_change_draft: "Change the post to draft ?",
    total: "Total",
    planned: "Planned",
    creas: "Content",
    light: "Light",
    premium: "Premium",
    targets: "Targets",
    active: "Active",
    accounts: "Accounts",
    character_count: "Character count",
    no_crea: "No content creation",
  }
}
